const CompanyRightsTypes = {
  FETCH_COMPANY_RIGHTS: 'FETCH_COMPANY_RIGHTS',
  FETCH_COMPANY_RIGHTS_EXCLUDES: 'FETCH_COMPANY_RIGHTS_EXCLUDES',
};

export default CompanyRightsTypes;
